import { render, staticRenderFns } from "./chat-message-fontes.vue?vue&type=template&id=bb2e2974&scoped=true&"
import script from "./chat-message-fontes.vue?vue&type=script&lang=js&"
export * from "./chat-message-fontes.vue?vue&type=script&lang=js&"
import style0 from "./chat-message-fontes.vue?vue&type=style&index=0&id=bb2e2974&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2e2974",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb2e2974')) {
      api.createRecord('bb2e2974', component.options)
    } else {
      api.reload('bb2e2974', component.options)
    }
    module.hot.accept("./chat-message-fontes.vue?vue&type=template&id=bb2e2974&scoped=true&", function () {
      api.rerender('bb2e2974', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/chat-message-fontes/chat-message-fontes.vue"
export default component.exports